<template>
    <div class="pt-1 sm:pt-5 px-2 bg-white dark:bg-slate-800 shadow space-y-6 lg:rounded-lg xl:px-4">
        <div class="pb-0 pl-0 pr-0">
            <div class="hidden sm:flex flex-col justify-center align-middle text-center">
                <div class="flex justify-center mb-1 mr-1 text-pink-500 text-6xl font-bold">
                    <span class="currency font-display">{{ post.pledgedAmount | toLocaleString }}</span>
                </div>
                <div class="text-pink-300 text-xs font-semibold uppercase">value of tokens pledged</div>
            </div>

            <div class="mt-4 xl:px-4" v-if="!post.isApproved">
                <challenge-buttons :post="post" />
                <challenge-request-button v-if="post.isCompeting" as="button" method="post" :href="route('attachUserToChallenge', { post: post })" class="disabled:bg-secondary-200 bg-secondary-500 hover:bg-secondary-400 active:bg-secondary-400"> Complete The Challenge </challenge-request-button>
                <div v-if="post.isCompeting" class="flex">
                    <hr class="flex-grow my-4 border-gray-300" />
                    <span class="flex-grow-0 place-self-center px-4 text-gray-500 text-xs uppercase">or</span>
                    <hr class="flex-grow my-4 border-gray-300" />
                </div>
                <jet-button class="w-full" @click.native="showPledgeModal = true"> Make A Pledge</jet-button>
            </div>

            <div class="pt-4 sm:hidden flex flex-col justify-center align-middle text-center">
                <div class="flex justify-center mb-1 mr-1 text-pink-500 text-5xl font-bold">
                    <span class="currency font-display">{{ post.pledgedAmount | toLocaleString }}</span>
                </div>
                <div class="text-pink-300 text-xs font-semibold uppercase">value of tokens pledged</div>
            </div>
        </div>

        <!-- Supporter Stats -->
        <div class="grid gap-1 grid-cols-3 text-center">
            <div class="col-span-1 dark:text-white">
                {{ post.pledgesCount | abbr }}
                <div class="text-gray-500 dark:text-slate-200 text-xs uppercase">
                    {{ "pledge" | pluralize(post.pledgesCount) }}
                </div>
            </div>
            <div class="col-span-1 dark:text-white">
                {{ post.likesCount | abbr }}
                <div class="text-gray-500 dark:text-slate-200 text-xs uppercase">
                    {{ "like" | pluralize(post.likesCount) }}
                </div>
            </div>
            <div class="col-span-1 dark:text-white">
                {{ post.commentsCount | abbr }}
                <div class="text-gray-500 dark:text-slate-200 text-xs uppercase">
                    {{ "comment" | pluralize(post.commentsCount) }}
                </div>
            </div>
        </div>

        <!-- Activity Feed -->
        <div v-if="showFeed" class="flow-root">
            <pledge-feed :post="post" />
        </div>

        <pledge-tokens-modal :show.sync="showPledgeModal" :options="options" />
    </div>
</template>

<script>
import JetButton from "@/Jetstream/Button"
import PledgeFeed from "@/Pages/Post/PledgeFeed"
import Tooltip from "@/Components/Tooltip"
import ChallengeButtons from "@/Pages/Post/ChallengeButtons"
import PledgeTokensModal from "@/Pages/Wallet/PledgeTokensModal"
import ChallengeRequestButton from "@/Pages/Post/ChallengeRequestButton.vue"

export default {
    components: {
        ChallengeRequestButton,
        PledgeTokensModal,
        ChallengeButtons,
        Tooltip,
        PledgeFeed,
        JetButton,
    },

    mounted() {
        if (this.options) this.showPledgeModal = this.options.show
    },

    props: {
        post: {
            type: Object,
            required: true,
        },
        showFeed: {
            type: Boolean,
            default: true,
        },
        options: {
            type: Object,
            default: () => ({ show: false }),
        },
    },

    data() {
        return {
            showPledgeModal: false,
        }
    },

    computed: {
        hasPendingCompetitors() {
            return this.post.pendingCompetitors && this.post.pendingCompetitors.length
        },
    },
}
</script>
